import { render, staticRenderFns } from "./CertificadoConvenioFileButton.vue?vue&type=template&id=2287bbd7&scoped=true"
import script from "./CertificadoConvenioFileButton.vue?vue&type=script&lang=js"
export * from "./CertificadoConvenioFileButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2287bbd7",
  null
  
)

export default component.exports